import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件
import idNameMixin from '@/mixins/id-name-mixin.js' // 引入mixin文件
import { VideoPlayerManager } from 'utils/video-player-manager'
import { getIndexById } from '@/utils/public.js'

export default {
  name: 'VideoPlayerModal',
  data () {
    return {
      // 遮罩层
      loading: false,
      // 视频控制区域
      controlTabsOpen: true, // 控制区域是否显示
      activeTabName: '0', // 活动控制页面索引
      // 云台控制
      hSpeed: 5,
      vSpeed: 5,
      // 预置点控制
      presetInfoTableData: [],
      presetInfoTableTotalRow: 0,
      persetInfoTableCurrentId: 0,
      persetInfoTableCurrentPresetNum: 0,
      presetInfoTableQueryParams: {
        nodeId: 0,
        pageNum: 1,
        pageSize: 2
      },
      // 控制节点列表
      controlNodeTableData: [],
      controlNodeTableTotalRow: 0,
      controlNodeTableCurrentItem: null,
      controlNodeTableCurrentId: 0,
      controlNodeTableCurrentDeviceOutputNum: 0,
      lastDataNodeUpdateDateTime: 0,
      controlNodeTableQueryParams: {
        streamNodeId: 0,
        beginUpdateDateTime: 0,
        dataNodeStateRequired: 1,
        pageNum: 1,
        pageSize: 2
      },
      // 视频播放器管理器
      tileVisible: true,
      playProtocol: this.$globalConfig.playProtocol, // 播放协议，0-rtmp,1-hls,2-http-flv,3-ws-flv
      playerManager: null
    }
  },
  props: {
    modalOpen: {
      type: Boolean,
      default: false
    },
    videoOpen: {
      type: Boolean,
      default: false
    },
    streamNodes: {
      type: Array,
      default: []
    }
  },
  computed: {
    players: function () {
      return this.playerManager.players
    },
    currentVideoPlayerId: function () {
      return this.playerManager.currentPlayerId
    },
    currentStreamNodeId: function () {
      return this.playerManager.currentStreamNodeId
    },
    isSingle: function () {
      return this.playerManager.isSingle()
    }
  },
  mixins: [
    convertorMixin,
    idNameMixin
  ],
  watch: {
    videoOpen: {
      immediate: true, // 很重要！！！
      handler(val) {
        if (val) {
          this.startAllVideos()
        }
      }
    }
  },
  created() {
    // 创建播放器管理器
    this.playerManager = new VideoPlayerManager()
  },
  mounted () {
    this.controlTabsOpen = false
    this.streamNodes.forEach(item => {
      if (item.streamObjectKind === 0 || item.streamObjectKind === 1) { // 只有球机才显示控制区域
        this.controlTabsOpen = true
      }
    })
    this.startAllVideos()
    // 开始数据轮巡
    this.startDataPolling()
  },
  beforeDestroy() {
    // 停止数据轮巡
    this.stopDataPolling()
    this.stopAllVideo()
  },
  methods: {
    // 查询预置点列表
    getPresetInfoList() {
      this.loading = true
      if (this.playerManager.currentStreamNodeId > 0) {
        this.presetInfoTableQueryParams.nodeId = this.playerManager.currentStreamNodeId
      } else if (this.streamNodes.length > 0) {
        this.presetInfoTableQueryParams.nodeId = this.streamNodes[0].id
      }
      this.$http(this.$api.presetInfoList, this.presetInfoTableQueryParams).then(
        res => {
          if (res.code === 200) {
            this.presetInfoTableData = res.data
            this.presetInfoTableTotalRow = res.page.totalRow
            if (res.data.length) {
              this.$refs.presetInfoTable.setCurrentRow(res.data[0]) // 选中首行
              this.persetInfoTableCurrentId = res.data[0].id
              this.persetInfoTableCurrentPresetNum = res.data[0].presetNum
            } else {
              this.persetInfoTableCurrentId = 0
              this.persetInfoTableCurrentPresetNum = 0
            }
          }
          this.loading = false
        }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 查询控制节点列表
    getControlNodeListForStreamNode() {
      this.loading = true
      if (this.playerManager.currentStreamNodeId > 0) {
        this.controlNodeTableQueryParams.streamNodeId = this.playerManager.currentStreamNodeId
      } else if (this.streamNodes.length > 0) {
        this.controlNodeTableQueryParams.streamNodeId = this.streamNodes[0].id
      }
      this.controlNodeTableQueryParams.beginUpdateDateTime = 0 // 忽略开始更新日期时间
      this.$http(this.$api.controlNodeListForStreamNode, this.controlNodeTableQueryParams).then(
        res => {
          if (res.code === 200) {
            res.data = res.data.filter(item => { // 过滤非信号量输入
              return item.resourceKind === 24
            })
            res.data.forEach(item => {
              if (item.dataNodeRealValue != null) { // 根据关联的数据节点采集值设置控制数值
                item.controlValue = item.dataNodeRealValue
              }
              item.controlState = this.$type.getResourceControlState(item.resourceKind, item.controlValue, item
                .valueType) // 根据控制数值返回控制状态
              item.inputControlState = item.controlState // 初始化输入控制状态

              // 更新数据节点最后更新日期时间
              if (item.dataNodeUpdateDateTime > this.lastDataNodeUpdateDateTime) {
                this.lastDataNodeUpdateDateTime = item.dataNodeUpdateDateTime
              }
            })

            this.controlNodeTableData = res.data
            this.controlNodeTableTotalRow = res.page.totalRow
            if (res.data.length) {
              this.controlNodeTableCurrentId = res.data[0].id
              this.controlNodeTableCurrentDeviceOutputNum = res.data[0].deviceOutputNum
            } else {
              this.controlNodeTableCurrentId = 0
              this.controlNodeTableCurrentDeviceOutputNum = 0
            }
          }
          this.loading = false
        }
      ).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 查询更新的控制节点列表
    getUpdatedControlNodeListForStreamNode() {
      // this.loading = true
      this.controlNodeTableQueryParams.beginUpdateDateTime = this.lastDataNodeUpdateDateTime + 1 // 设置开始更新日期时间
      this.$http(this.$api.controlNodeListForStreamNode, this.controlNodeTableQueryParams).then(
        res => {
          if (res.code === 200) {
            res.data.forEach(item => {
              if (item.dataNodeRealValue != null) { // 根据关联的数据节点采集值设置控制数值
                item.controlValue = item.dataNodeRealValue
              }
              if (item.resourceKind === 24) { // 信号量输出
                item.controlState = this.$type.getResourceControlState(item.resourceKind, item.controlValue,
                  item.valueType) // 根据控制数值返回控制状态
                item.inputControlState = item.controlState // 初始化输入控制状态
              } else if (item.resourceKind === 25) { // 模拟量输出
                item.inputControlState = item.controlValue // 初始化输入控制状态
              }
              let listItemIndex = getIndexById(item.id, this.controlNodeTableData)
              if (listItemIndex >= 0) {
                this.$set(this.controlNodeTableData, listItemIndex, item) // 强制刷新数组元素
              }
              // 更新数据节点最后更新日期时间
              if (item.dataNodeUpdateDateTime > this.lastDataNodeUpdateDateTime) {
                this.lastDataNodeUpdateDateTime = item.dataNodeUpdateDateTime
              }
            })
          }
          // this.loading = false
        }).catch(err => {
        console.log(err)
        // this.loading = false
      })
    },
    //
    startAllVideos () {
      if (this.streamNodes.length > 1) {
        this.playerManager.switchLayout({ name: '四画面', count: 4 })
      } else {
        this.playerManager.switchLayout({ name: '单画面', count: 1 })
      }

      this.streamNodes.forEach((item, index) => {
        item.audioEnabled = false
        item.accessToken = this.$store.getters.userToken
        item.playProtocol = this.playProtocol
      })
      this.playerManager.closeAll()
      this.playerManager.openVideoPlayers(this.streamNodes)
    },
    // 选中视频播放器
    selectVideoPlayer(videoPlayer) {
      this.playerManager.select(videoPlayer)
      this.getPresetInfoList()
    },
    // 抓图
    capturePictureJpeg() {
      if (this.playerManager.currentPlayer === null) {
        this.$messagebox.confirm('请先打开当前选中摄像机视频！', '提示', {
          confirmButtonText: '知道了',
          showCancelButton: false,
          type: 'warning'
        })
      } else {
        let params = {
          accessToken: this.$store.getters.userToken,
          nodeId: this.playerManager.currentStreamNodeId,
          streamOpenMode: Number(this.playerManager.currentPlayer.streamOpenMode),
          pictureFormat: 1
        }
        this.$http(this.$api.capturePicture, params).then(
          res => {
            if (res.code === 200) {
              window.open(res.data.pictureUrl)
            }
          }
        )
      }
    },
    // 关闭指定视频
    stopVideo(streamNodeId) {
      this.playerManager.closeVideoPlayer(streamNodeId)
    },
    // 关闭全部视频
    stopAllVideo() {
      this.playerManager.closeAll()
    },
    // 云台控制
    ptzControl(ptzCmd) {
      if (this.playerManager.currentPlayer === null) {
        this.$messagebox.confirm('请先打开当前选中摄像机视频！', '提示', {
          confirmButtonText: '知道了',
          showCancelButton: false,
          type: 'warning'
        })
      } else {
        let params = {
          accessToken: this.$store.getters.userToken,
          nodeId: this.playerManager.currentStreamNodeId,
          ptzCmd: ptzCmd,
          hSpeed: this.hSpeed,
          vSpeed: this.vSpeed
        }
        this.$http(this.$api.ptzControl, params).then(
          res => {
            if (res.code === 200) {
              console.log(res.data)
            }
          }
        )
      }
    },
    // 预置点控制
    presetControl(presetCmd) {
      if (this.playerManager.currentPlayer === null) {
        this.$messagebox.confirm('请先打开当前选中摄像机视频！', '提示', {
          confirmButtonText: '知道了',
          showCancelButton: false,
          type: 'warning'
        })
      } else {
        if (this.presetInfoTableData.length === 0) return

        let params = {
          nodeId: this.playerManager.currentStreamNodeId,
          presetCmd: presetCmd,
          presetId: 0,
          presetNum: this.persetInfoTableCurrentPresetNum
        }
        this.$http(this.$api.presetControl, params).then(
          res => {
            if (res.code === 200) {
              console.log(res.data)
            }
          }
        )
      }
    },
    // do控制
    doControl() {
      if (this.controlNodeTableCurrentItem === null) {
        this.$messagebox.confirm('请先选中一条记录！', '提示', {
          confirmButtonText: '知道了',
          showCancelButton: false,
          type: 'warning'
        })
      } else {
        let queryText = this.controlNodeTableCurrentItem.controlState === 0 ? '您确定打开【' : '您确定关闭【'
        queryText += this.controlNodeTableCurrentItem.name
        queryText += '】吗?'
        this.$messagebox.confirm(queryText, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let controlParams = {
            nodeId: this.controlNodeTableCurrentItem.id,
            controlCmd: this.controlNodeTableCurrentItem.inputControlState === 1 ? 0 : 1 // 控制命令，0-打开，1-关闭，2-禁止关(常开)，3-禁止开(常闭)，4-恢复普通模式(允许开关)
          }
          this.$http(this.$api.doControl, controlParams).then(
            res => {
              if (res.code === 200) {
                this.controlNodeTableCurrentItem.controlValue = this.controlNodeTableCurrentItem
                  .controlValue === 0 ? 1 : 0
                this.controlNodeTableCurrentItem.controlState = this.$type.getResourceControlState(this
                  .controlNodeTableCurrentItem.resourceKind, this.controlNodeTableCurrentItem
                  .controlValue, this.controlNodeTableCurrentItem.valueType) // 根据控制数值返回控制状态
                if (this.controlNodeTableCurrentItem.dataNodeRealValue != null) { // 根据关联的数据节点采集值设置控制数值
                  this.controlNodeTableCurrentItem.dataNodeRealValue = this.controlNodeTableCurrentItem
                    .controlValue
                }
                this.$message({
                  type: 'success',
                  message: '操作成功!'
                })
              } else {
                this.controlNodeTableCurrentItem.inputControlState = this.controlNodeTableCurrentItem
                  .controlState // 恢复控制前状态
              }
            }
          )
        }).catch(() => {
          this.controlNodeTableCurrentItem.inputControlState = this.controlNodeTableCurrentItem
            .controlState // 恢复控制前状态
        })
      }
    },
    // 开始数据轮巡
    startDataPolling() {
      this.pollingTimer = setInterval(() => {
        if (this.loading) { // 检测上一次查询是否尚未结束
          return
        }

        if (this.activeTabName === '0') { // 云台控制

        } else if (this.activeTabName === '1') { // 预置点
        } else if (this.activeTabName === '2') { // 辅助控制
          this.controlNodeTableData.length > 0 ? this.getUpdatedControlNodeListForStreamNode() : this
            .getControlNodeListForStreamNode()
        }
      }, this.$globalConfig.pagePollingInterval)
    },
    // 停止数据轮巡
    stopDataPolling() {
      if (this.pollingTimer != null) {
        clearInterval(this.pollingTimer)
        this.pollingTimer = null
      }
    },
    // tab页面切换
    handleTabClick(tab) {
      if (this.activeTabName === '0') { // 云台控制

      } else if (this.activeTabName === '1') { // 预置点
        this.getPresetInfoList()
      } else if (this.activeTabName === '2') { // 辅助控制
        this.controlNodeTableData.length > 0 ? this.getUpdatedControlNodeListForStreamNode() : this
          .getControlNodeListForStreamNode()
      }
    },
    // 预置点控制页面------------------------------------------------------------------------------------------------
    // 预置点表格当前记录改变
    handlePresetInfoTableCurrentChange(currentRow, oldCurrentRow) {
      if (currentRow == null) {
        return
      }

      this.persetInfoTableCurrentId = currentRow.id
      this.persetInfoTableCurrentPresetNum = currentRow.presetNum
    },
    // 预置点表格分页
    handlePresetInfoCurrentPageChange(val) {
      this.presetInfoTableQueryParams.pageNum = val
      this.getPresetInfoList()
    },
    // 辅助控制页面------------------------------------------------------------------------------------------------
    // 控制节点表格当前记录改变
    handleControlNodeTableCurrentChange(currentRow, oldCurrentRow) {
      if (currentRow == null) {
        return
      }

      this.controlNodeTableCurrentItem = currentRow
      this.controlNodeTableCurrentId = currentRow.id
      this.controlNodeTableCurrentDeviceOutputNum = currentRow.deviceOutputNum
    },
    // 控制节点表格分页
    handleControlNodeCurrentPageChange(val) {
      this.controlNodeTableQueryParams.pageNum = val
      this.getControlNodeListForStreamNode()
    },
    // 开关切换
    switchChange(item) {
      this.controlNodeTableCurrentItem = item
      this.controlNodeTableCurrentId = item.id
      this.controlNodeTableCurrentDeviceOutputNum = item.deviceOutputNum
      this.doControl()
    },
    // 取消提交记录
    handleModalCancel () {
      this.playerManager.closeAll()
      this.$emit('cancel', false)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/common/VideoPlayerModal/VideoPlayerModal.js